import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { KnownBusinessEntityRentalDispenseItem } from "@/models/known-business-entity-rental-dispense-item.model.ts"
import { usePriceAgreementsConstantTimeLookup } from "@/composables/store/price-agreements-constant-time-lookup"

export const useKnownBusinessEntitiesRentalDispenseItemsStore = defineStore(
  "knownBusinessEntitiesRentalDispenseItemsStore",
  () => {
    const knownBusinessEntitiesRentalDispenseItems: Ref<KnownBusinessEntityRentalDispenseItem[]> =
      ref([])

    const { getPriceAgreement, getUnitPrice } =
      usePriceAgreementsConstantTimeLookup<KnownBusinessEntityRentalDispenseItem>(
        knownBusinessEntitiesRentalDispenseItems,
        (item) => [item.knownBusinessEntity, item.rentalDispenseItem],
        (item) => item.unitPricePerDay
      )

    return {
      knownBusinessEntitiesRentalDispenseItems,
      getPriceAgreement,
      getUnitPrice
    }
  }
)
